import UltMeta, { Meta } from "./UltMeta/index";

/**
 *发布类型
 */
class ReadState extends UltMeta {
    UNREAD = new Meta(1, "未读");
    READ = new Meta(2, "已读");
    DELETED = new Meta(3, "已删除");
}
export const READ_STATE = new ReadState();
